import HttpClient from "@lib/http-client";

/**
 * @memberof Services
 */
class CourseService extends HttpClient {
  async getCourseList() {
    return this.http.get(`/courses/all`);
  }

  getOrganizationPrograms(orgCode) {
    return this.http.get(`/organization/${orgCode}/courses`);
  }

  async getCourseDetails(courseId, params = {}) {
    return this.http.get(`/courses/course/${courseId}`, { params });
  }

  async getLessonDetails(lessonId, organizationCode) {
    const params = organizationCode
      ? { organization_code: organizationCode }
      : {};

    return this.http.get(`/courses/lessons/${lessonId}/activities`, { params });
  }

  async getCourseCredentials(courseId) {
    const apiUrl = `courses/credential/${courseId}`;
    return this.http.get(apiUrl);
  }

  async getActivityDependencies(courseId) {
    return this.http.get(`/courses/course/${courseId}/dependencies`);
  }

  async getCredentialInfoByUserId(userId, body) {
    return this.http.post(`courses/credential/${userId}`, body);
  }

  async getCredentialLink(userId, groupId) {
    return this.http.get(`courses/credential/group/${groupId}/user/${userId}`);
  }

  async getCourseActivities(courseId) {
    return this.http.get(`/courses/activities/course/${courseId}`);
  }

  async getAwardsLinksByClassroom(classroomId) {
    return this.http.get(`/courses/credential/classroom/${classroomId}`);
  }

  async sendProgramInfo(programData) {
    return this.http.post(`/courses/course`, programData);
  }

  async getOrgActivities(orgCode) {
    return this.http.get(`/organization/${orgCode}/activities`);
  }

  async deleteUnit(unitId, courseId) {
    return this.http.delete(`/courses/${courseId}/unit/${unitId}`);
  }

  async deleteLesson(lessonId, courseId) {
    return this.http.delete(`/courses/${courseId}/lesson/${lessonId}`);
  }

  async getCourseActivityLogs(courseId) {
    return this.http.get(
      `/client-services/templates/programs/${courseId}/activity-log`
    );
  }
}

export default CourseService;
